module.exports = __webpack_public_path__ + "img/native-speaker.b9eb8882.jpg";